module.exports = __webpack_public_path__ + "static/media/grosbisou.d2713b57.gif";